import React,{useState} from "react";
import { Typography } from "@mui/material";
import DateRangeField from "./DateRangeField";

export default function DateSearchForm({ value, onChange,disabled }) {
  const [openField, setOpenField] = useState(null);
  const update = (key, data) => {
    onChange({ ...value, [key]: data });
  };

  return (
    <>
      <Typography variant="subtitle2">Date Filters</Typography>

      <DateRangeField
        fieldKey="apptDate"
        label="Appointment Date"
        value={value.apptDate}
        onChange={(v) => update("apptDate", v)}
        openField={openField}
        setOpenField={setOpenField}
        disabled={disabled}
      />

      <DateRangeField
        fieldKey="billingDate"
        label="Billing Date"
        value={value.billingDate}
        onChange={(v) => update("billingDate", v)}
        openField={openField}
        setOpenField={setOpenField}
        disabled={disabled}
      />

      <DateRangeField
        fieldKey="returnDate"
        label="Return Date"
        value={value.returnDate}
        onChange={(v) => update("returnDate", v)}
        openField={openField}
        setOpenField={setOpenField}
        disabled={disabled}
      />

      <DateRangeField
        fieldKey="docUploadDate"
        label="Doc Upload Date"
        value={value.docUploadDate}
        onChange={(v) => update("docUploadDate", v)}
        openField={openField}
        setOpenField={setOpenField}
        disabled={disabled}
      />
    </>
  );
}